import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/mapazoom.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad2Actividad2.mp3";

const Actividad3 = () => {
  const infoUnidad = modulo13.content[1];
  const infoAct = modulo13.content[1].activities[1];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[1].name}: ${modulo13.content[1].activities[2].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[2].path}`,
    titlePrev: `${modulo13.content[1].name}: ${modulo13.content[1].activities[0].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[1].path}/${modulo13.content[1].activities[0].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEye} /> Observamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="">
        <li>Observa este detalle de la imagen de la actividad anterior.</li>
      </ul>
      <img src={Imagen1} className="img-fluid" alt="Peruanos" />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul className="mt-5">
            <li>
            Dialoga con un compañero, compañera o familiar y responde: ¿Qué problema se observa en la imagen? ¿Qué hicieron las personas para que ocurriera esto?
            </li>
          </ul>
          <textarea className="form-control mb-4" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Lea las indicaciones: Observa este detalle de la imagen anterior.
            Dialoga con tu compañero o compañera. ¿Qué problema se observa en la
            imagen? ¿Qué hicieron las personas para que ocurriera esto? Dé un
            tiempo para que trabajen en parejas y luego retome
            sus respuestas:
            <ul>
              <li>
                <i>
                  “¿Qué problema se observa en la imagen? (Posible respuesta: Se
                  observa la contaminación del mar por el desagüe).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué hicieron las personas para que ocurriera esto? (Posible
                  respuesta: Las personas no tomaron en cuenta que su decisión
                  de construir un desagüe hacia el mar trae como consecuencia su
                  contaminación).”
                </i>
              </li>
            </ul>
          </li>
          <li>
            Cierre la actividad pidiéndo que regresen al
            mapa presentado en la actividad anterior y que señalen qué recursos
            se ven afectados con la contaminación del mar.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
